import type { FC, ReactNode } from "react";
import { InfoIconTooltip } from "../tooltip/infoIconTooltip.js";

export interface CustomerTimelineActivityDetailsProps {
  /** One short line, such as "Call requested". */
  children: ReactNode;
  /** Explains the activity in a tooltip beside the line. */
  info?: ReactNode;
}

/**
 * An activity row's details: one line of muted text that can't be opened. It
 * marks its row as activity, which sets the spacing around it.
 */
export const CustomerTimelineActivityDetails: FC<
  CustomerTimelineActivityDetailsProps
> = (props) => {
  const { children, info } = props;
  // The top padding centers the 16px line on the rail's node, 12px down.
  return (
    <div
      data-customer-timeline-activity
      className="flex items-center gap-1 pt-1 text-xs text-muted-foreground"
    >
      {children}
      {info && <InfoIconTooltip>{info}</InfoIconTooltip>}
    </div>
  );
};
